import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MaterialSymbol from '../MaterialSymbol';
import { MOBILE_ICON_BUTTON_SIZE } from './constants';
import { HOVERED_ICON_BUTTON_SX, PRESSED_ICON_BUTTON_BGCOLOR } from '../highContrastSx';

export const TITLE_SX = theme => ({
    flex: 1,
    color: 'text.primary',
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    lineHeight: 1.5,
});

const CLOSE_BUTTON_SX = {
    color: 'text.primary',
    width: MOBILE_ICON_BUTTON_SIZE,
    height: MOBILE_ICON_BUTTON_SIZE,
    '&:hover': HOVERED_ICON_BUTTON_SX,
    '&:active': { bgcolor: PRESSED_ICON_BUTTON_BGCOLOR },
};

function MobileSearchMode({ title, closeLabel, onClose }) {
    return (
        <Box
            sx={{
                display: { xs: 'flex', lg: 'none' },
                alignItems: 'center',
                width: '100%',
                height: '100%',
            }}
            data-testid="redesign-mobile-search-mode"
        >
            <Typography
                variant="h6"
                component="h1"
                sx={TITLE_SX}
                data-testid="redesign-mobile-search-title"
            >
                {title}
            </Typography>
            <IconButton
                aria-label={closeLabel}
                onClick={onClose}
                sx={CLOSE_BUTTON_SX}
                data-testid="redesign-mobile-search-close"
            >
                <MaterialSymbol name="close" size={20} />
            </IconButton>
        </Box>
    );
}

MobileSearchMode.propTypes = {
    title: PropTypes.string.isRequired,
    closeLabel: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default MobileSearchMode;
